module.exports = __webpack_public_path__ + "img/logo-white.9bcb7d2e.png";